<template>
    <div class="flex justify-center flex-wrap">
        <div class='text-center'>
            <a v-if="templateArgs.data.arquivo" :href='templateArgs.data.arquivo' target="_blank" class='btn btn btn-grey btn-sm' title='Abrir'>
                <i class='fa fa-arrow-right'></i> {{ getUrl }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'templateAbrir',
    computed: {
        getUrl() {
            const test = /\/editais\//.exec(this.templateArgs.data.arquivo)
            if(test && test.length) {
                return 'Download'
            } else {
                return 'Abrir'
            }

        }
    },
    data: () => ({
        templateArgs: {}
    })
}
</script>

<style lang="scss" scoped>
</style>